<template>
  <div class="container">
    <div class="container log_or_reg_main">      
      <Welcome
        :text_colour="invitation?.campaign?.text_colour"
        :elem_colour="invitation?.campaign?.elem_colour" 
        :public_name="invitation?.campaign?.public_name"
      />
      <div class="card">
        <router-link :to="{ name: 'game-login' }">
          <img class="logo" src="/images/logo-font-white.svg" alt="Logo yuzu" />
        </router-link>
        <div class="block">
          <p>
            <span class="primary-color bold">{{
              invitation?.campaign?.public_name
            }}</span
            > vous invite à rejoindre sa campagne Yuzu.
          </p>
          <br />
          <p>
            Acceptez-vous de rejoindre cette campagne et de transmettre l'ensemble de vos résultats déjà collectés ?
          </p>
        </div>
        <div class="form-container">
          <div class="checkbox-group">
            <input
              type="checkbox"
              id="campaignOptin"
              name="campaignOptin"
              v-model="state.campaignOptin"
            />
            <label for="campaignOptin"
              >J’accepte de rejoindre cette campagne de recrutement</label
            >
          </div>
          <div class="checkbox-group">
            <input
              type="checkbox"
              id="dataOptin"
              name="dataOptin"
              v-model="state.dataOptin"
            />
            <label for="dataOptin"
              >J'accepte de transmettre mes résultats déjà collectés</label
            >
          </div>
        </div>
        <Button
          class="primary"
          label="Rejoindre cette nouvelle campagne"
          :disabled="!state.campaignOptin || !state.dataOptin"
          :style="(state.campaignOptin && state.dataOptin) ? getThemeStyle(invitation?.campaign) : ''"
          @click="consentToJoin"
        />
      </div>      
  </div>
  </div>
</template>

<script setup>
import { reactive } from "vue";
import { useCandidateStore } from "@/stores/candidate.js";
import { storeToRefs } from "pinia";
import { useToast } from "vue-toastification";
import { getError } from "@/composables/error.js";
import { useRouter, useRoute } from "vue-router";
import { getImage } from "@/composables/getImage.js";
import Welcome from "./InviteWelcome.vue";

const emits = defineEmits(["setBackground"]);

const router = useRouter();

const route = useRoute();

const toast = useToast();

const candidateStore = useCandidateStore();

const { invitation, candidate } = storeToRefs(candidateStore);

const state = reactive({
  campaignOptin: false,
  dataOptin: false,
});

if(invitation.value.campaign.bg_image_id) {
  const imageBGUrl = getImage(invitation.value.campaign.bg_image_id);
  emits("setBackground", imageBGUrl);
}

async function consentToJoin() {
  const resp = await candidateStore.joinNewCampaignFromInvitation(
    route.query.invitation_id
  );

  if (resp.key) {
    toast.error(getError(resp.key));
  } else {
    toast.success(
      `Vous venez de rejoindre la campagne: ${invitation.value.campaign.public_name}`
    );
  }

  const invitationIsMine = invitation.value.email === candidate.value.email;
  const publicInvitationConnected =
    !invitation.value.email && candidate.value.email;

  if (invitationIsMine || publicInvitationConnected) {
    router.push({ name: "game-home" });
  } else {
    candidateStore.logout();
  }
}

function getThemeStyle (campaign) {
  if(!campaign) {
    return '';
  }

  var bgColour = "#f2cb36";
  var textColour = "#000000";

  return {
  'background-color': campaign.elem_colour ? campaign.elem_colour : bgColour,
  'color': campaign.text_colour ? campaign.text_colour : textColour,
  };
}

</script>
